import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { DestroyerComponent } from '@components/app-core/components/destroyer/destroyer.component'
import { takeUntil } from 'rxjs/operators'
import { CommonModule } from '@angular/common'
import { toBoolean } from '@utils/boolean-utils'
import { TranslationService } from '@services/translation/translation.service'

@Component({
  selector: 'app-home-button',
  templateUrl: './home-button.component.html',
  styleUrls: ['./home-button.component.scss'],
  standalone: true,
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
})

export class HomeButtonComponent extends DestroyerComponent implements OnInit {
  @Input() breadcrumb = ''
  @Input() icon: string | null = ''
  @Input() isLoggedIn: boolean | 'true' | 'false' = false
  @Input() path: string | null = null

  title = ''

  constructor(private readonly translationService: TranslationService) {
    super()
  }

  ngOnInit(): void {
    this.typeCastPath()
    this.typeCastIsLoggedIn()
    this.fetchTitle()
  }

  // PRIVATE

  private fetchTitle(): void {
    const code = 'navigation.bcHome.label'
    this.translationService
      .getTranslation([{code, default: 'Return to homepage'}])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (value) => {
          this.title = value[code].value
        },
      })
  }

  private typeCastIsLoggedIn(): void {
    this.isLoggedIn = toBoolean(this.isLoggedIn)
  }

  private typeCastPath(): void {
    if (typeof this.path === 'string') this.path = `${this.path}/?h=true`
  }

}
